import { BALANCE_QUERY, BALANCE_CURRENCY_QUERY, LANGUAGE_UPDATED, ACCOUNT_PEP_BLOCK_QUERY, BALANCE_UPDATED, BALANCE_CHANGED, BALANCE_CURRENCY_UPDATED, IP_COUNTRY_QUERY, LANGUAGE_QUERY } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { countryToCurrency, languageToCurrency } from '@gig/magic-common/dist/util/helpers/currency';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class BalanceService {
  constructor() {
    this.balance = null;
    this.currency = null;
    this.registerBalanceQuery();
    this.registerCurrencyQuery();
    this.subscribeToBalanceChanges();
    this.subscribeToLanguageChanges();
  }
  registerBalanceQuery() {
    window.queryBus.subscribe(BALANCE_QUERY, () => {
      return this.balance;
    });
  }
  registerCurrencyQuery() {
    window.queryBus.subscribe(BALANCE_CURRENCY_QUERY, () => __async(this, null, function* () {
      return yield this.getCurrency();
    }));
  }
  subscribeToBalanceChanges() {
    this.registerBalanceEvents();
    if (magic.session.isCreated()) {
      this.handleSessionCreated();
    } else {
      this.handleSessionDestroyed();
    }
    magic.events.sessionCreated(() => this.handleSessionCreated());
    magic.events.sessionDestroyed(() => this.handleSessionDestroyed());
  }
  subscribeToLanguageChanges() {
    this.registerCurrencyEvents();
    window.eventBus.subscribe(LANGUAGE_UPDATED, () => __async(this, null, function* () {
      yield this.publishCurrencyChange();
    }));
  }
  handleSessionCreated() {
    return __async(this, null, function* () {
      yield this.publishCurrencyChange();
      const user = magic.session.getUser();
      if (!user) {
        console.warn("user is not saved in session");
        return;
      }
      const isPepBlocked = yield window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY);
      if (isPepBlocked) {
        return;
      }
      const balance = yield magic.invokeCached(10, magic.methods.wallet, "getComputedBalance")(user.currency);
      this.publishBalanceUpdated(balance);
      this.unsubscribeBalanceChanges();
      this.balanceSubscription = magic.events.computedBalanceChanged((balance2) => {
        this.publishBalanceUpdated(balance2);
        this.publishBalanceChanged(balance2);
      });
    });
  }
  handleSessionDestroyed() {
    return __async(this, null, function* () {
      yield this.publishCurrencyChange();
      this.publishBalanceUpdated(null);
      this.unsubscribeBalanceChanges();
    });
  }
  publishBalanceUpdated(balance) {
    this.balance = balance;
    window.eventBus.publish(BALANCE_UPDATED, balance);
  }
  publishBalanceChanged(balance) {
    window.eventBus.publish(BALANCE_CHANGED, balance);
  }
  publishCurrencyChange() {
    return __async(this, null, function* () {
      this.currency = yield this.getCurrency();
      window.eventBus.publish(BALANCE_CURRENCY_UPDATED, this.currency);
    });
  }
  unsubscribeBalanceChanges() {
    if (this.balanceSubscription) {
      this.balanceSubscription.unsub();
      this.balanceSubscription = void 0;
    }
  }
  getCurrency() {
    return __async(this, null, function* () {
      const user = magic.session.getUser();
      if (user) {
        return user.currency;
      }
      const [country, language] = yield Promise.all([
        window.queryBus.query(IP_COUNTRY_QUERY),
        window.queryBus.query(LANGUAGE_QUERY)
      ]);
      const countryCurrency = country ? countryToCurrency(country) : Currency.EUR;
      if (language) {
        return languageToCurrency(language, countryCurrency);
      }
      return countryCurrency;
    });
  }
  registerBalanceEvents() {
    window.eventBus.register(BALANCE_UPDATED, {
      anyOf: [
        {
          type: "object",
          properties: {
            balance: {
              type: "number"
            },
            realBalance: {
              type: "number"
            },
            bonusBalance: {
              type: "number"
            },
            bonusRealMoneyBalance: {
              type: "number"
            },
            bonusBonusMoneyBalance: {
              type: "number"
            }
          }
        },
        {
          type: "null"
        }
      ]
    });
  }
  registerCurrencyEvents() {
    window.eventBus.register(BALANCE_CURRENCY_UPDATED, {
      anyOf: [
        {
          type: "string"
        },
        {
          type: "null"
        }
      ]
    });
  }
}

export { BalanceService };
